<template>
  <div v-if="workListStore.workWidgetSummaryList.length > 0" style="background: transparent; padding: 0px; height: 100%; border-radius: 12.5px">
    <!-- <span v-if="AreIdsShown"> workListStore.workWidgetSummaryList dueTextSummary {{ workListStore.workWidgetSummaryList[0].dueTextSummary }}</span> -->
    <!-- <span v-if="AreIdsShown">widgetGridDataArray {{ workListStore.workWidgetSummaryList[0].widgetGridDataArray.length }}</span> -->
    <!-- #B0C1B2 AreIdsShown {{ AreIdsShown }} -->

    <div v-if="AreIdsShown" style="background: darkturquoise; color: white">
      <!-- <p>workListStore.workWidgetSummaryList[0].selectedTaskTypeFilters</p> -->
      <!-- <h4 style="background:darkblue;color:white;">
selectedTaskTypeFilters {{selectedTaskTypeFilters}}</h4> -->

      <!-- <br /> -->

      <!-- <span>12 {{ workListStore.workWidgetSummaryList[0].selectedTaskTypeFilters }}</span> -->
      <!-- <span>13 {{ workListStore.workWidgetSummaryList[1].selectedTaskTypeFilters }}</span> <br /> -->
      <!-- <span>14 {{ workListStore.workWidgetSummaryList[2].selectedTaskTypeFilters }}</span> -->
      <!-- <span>15 {{ workListStore.workWidgetSummaryList[3].selectedTaskTypeFilters }}</span> <br /> -->
    </div>

    <!-- <b-button variant="dark-orange" @click="GetWidgetList()">dark-orange</b-button> -->

    <span v-if="AreIdsShown" class="title is-6" style="background: darkblue; color: cyan">
      <span v-if="AreIdsShown"> current Selected widget : {{ workListStore.currentSelectedWorkSummaryWidget.id }} {{ workListStore.currentSelectedWorkSummaryWidget.name }}</span>
      <h6 v-if="AreIdsShown" class="title is-6" style="background: red; color: yellow">selectedTaskTypeFilters : {{ workListStore.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters }}</h6>
    </span>

    <b-form-tags
      :class="modalTheme"
      v-model="workListStore.workWidgetSummaryList"
      no-outer-focus
      class="mb-0"
      style="background: transparent; padding: 0px; width: 100%; height: 100%"
      tag-pills
      size="xs"
    >
      <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
        <div
          id="my-custom-tags-list"
          style="background: transparent; padding: 6px; max-height: 100vh; overflow-y: auto"
          class="list-unstyled d-inline-flex flex-wrap mb-0"
          aria-live="polite"
          aria-atomic="false"
          aria-relevant="additions removals"
        >
          <b-input-group aria-controls="my-custom-tags-list">
            <!-- <b-form-input v-bind="inputAttrs"
          v-on="inputHandlers" type="search" id="dx-term" size="sm" v-model="searchTerm" placeholder="DX Code Search Term" required></b-form-input> -->
            <!-- ? OFF  INPUT TO ADD to ARRAY  is   OFF  -->
            <!-- <b-form-input id="input-sm" size="sm" type="text" v-bind="inputAttrs" v-on="inputHandlers"
              placeholder="New tag - Press enter to add" name="title" class="form-control"
              :class="{ 'is-invalid': !inputAttrs }"></b-form-input>
            <b-input-group-append>
              <b-button @click="addTag()" variant="primary" size="sm">Add</b-button>
            </b-input-group-append> -->
          </b-input-group>
          <!-- <b-card-group deck> -->
          <!-- <h6 style="color:lime;"> tags {{tags}}</h6> -->
          <!-- <Widget v-for="(msg, index) in tags" :msg="msg" :key="index" class="panel-container" /> -->
          <!-- {{ tags[5] }} -->
          <!-- <div v-if="tag.id !== 6" style="color:yellow;">TEST</div> -->
          <div
            v-for="tag in tags"
            :key="tag"
            :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
            tag="div"
            class="mt-0 mr-0"
            body-class="py-0 pr-0 text-nowrap"
            style="background: transparent; color: transparent; padding: 0px; overflow: auto; max-height: 80vh; width: 200px"
          >
            <!-- <h3 v-if="AreIdsShown" style="color:cyan;">{{ JSON.parse(tag).selectedTaskTypeFilters }}</h3> -->
            <!-- {{ JSON.parse(tag).id }} {{ JSON.parse(tag).name }} -->
            <!-- <h4 v-if="AreIdsShown" style="color:blue;">{{ JSON.parse(tag).selectedTaskTypeFilters }}  </h4> -->
            <!-- {{ JSON.parse(tag).sourceId }} -->

            <h6 v-if="AreIdsShown" style="color: blue">
              {{ JSON.parse(tag).sourceId }}
              <!-- {{ JSON.parse(tag).sourceId }} -->
              <!-- {{ JSON.parse(tag).sourceType }} -->
              <!-- {{ JSON.parse(tag).selectedRecords }} -->
              <!-- {{ JSON.parse(tag).selectedTaskTypeFilters }} -->
              <!-- <span style="color:green;"> {{ JSON.parse(tag).dueTextSummary.length }}</span> -->
              <!-- <span style="color:green;"> {{ JSON.parse(tag).widgetGridDataArray.length }}</span> -->
              <!-- selectedTaskTypeFilters -->
              <!-- {{ selectedTaskTypeFilters }} -->
              <span style="color: cyan">selectedTaskTypeFilters : {{ JSON.parse(tag).selectedTaskTypeFilters }}</span>
              <span style="color: yellow">{{ JSON.parse(tag).widgetTaskTypeFilterItems.length }}</span>
            </h6>
            <!--
            <h6 v-if="![6].includes(workListStore.currentSelectedWorkSummaryWidget.id)" >{{ tag.id }}
              {{ tag.widgetGridDataArray.length }}
            </h6> -->
            <b-button :class="modalTheme" @click="showWorkTagINFO(tag)" size="sm" variant="dark-blue">
              <b-col style="padding: 0px">
                <h6>{{ JSON.parse(tag).name }}</h6>
              </b-col>
              <b-col style="padding: 0px">
                <WidgetThumbChart :widgetData="JSON.parse(tag)" :widget="workListStore.currentSelectedWorkSummaryWidget" :widgetType="workListStore.currentSelectedWorkSummaryWidget.widgetType" />
              </b-col>
              <!-- <b-col>
                <b-row style="padding:0px;">
                  <b-badge variant="success" style="color:#eaf7eb">
                    <h6 style="color:yellow;">{{ JSON.parse(tag) }}</h6>
                  </b-badge>
                </b-row>
                <b-row style="padding:0px;">
                  <b-badge variant="danger" style="color:#eaf7eb">
                    <h6 style="color:white;">{{ JSON.parse(tag).status }}</h6>
                  </b-badge>
                </b-row>
              </b-col> -->
            </b-button>
            <b-button v-if="AreIdsShown" aria-keyshortcuts="Delete" type="button" aria-label="Remove tag" variant="primary" class="close b-form-tag-remove" @click="removeTag(tag)" size="sm">
              <b-badge style="background: rgba(255, 0, 0, 0.695); color: white">x</b-badge>
            </b-button>
            <!-- v-b-toggle.collapse-2
          <b-collapse id="collapse-2">
            <b-card>I am collapsible content!</b-card>
          </b-collapse> -->
            <!-- <button
            @click="removeTag(tag)"
            class="close b-form-tag-remove"
            variant="link"
            size="sm"
            :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
          >xXx</button> -->
            <!-- <Widget :msg="tag" :key="tag" :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" tag="card"
  class="panel-container my-custom-tags-list" /> -->
          </div>
        </div>
      </template>
    </b-form-tags>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
import { useStoreWorkList } from "@/stores/workListsStore";
import WidgetThumbChart from "./WidgetThumbChart.vue";

// * EMITTER
const emit = defineEmits(["emitRender"]);

const workListStore = useStoreWorkList();
const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);

async function showWorkTagINFO(e) {
  // console.clear()
// console.log(" >> SHOW    WORK      TAG INFO");
// console.dir(e);
  // console.log(' toggle showDETAILS')
  // this.showDETAILS = true;
  // this.selectedWidget = e;
  // console.log(" _______this.selectedWidget______________________________0__");
  // console.log(JSON.parse(this.selectedWidget));

// console.log(" STORE SET Mut 														setSelectedWorkSummaryWidget  ");
  // this.$store.commit('setSelectedWorkSummaryWidget', this.selectedWidget)
  // console.log(' STORE SET Mut 		x         setWidgetWorkFilters')
  // this.$store.commit('setWidgetWorkFilters', this.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters)
// console.log(" new       STORE SET Mut 														setSelectedWorkSummaryWidget  ");
  workListStore.setSelectedWorkSummaryWidget(e);

  // // ? NEW
  // if (curSTaskFilter !== undefined || curSTaskFilter.length > 0) {
  // }

  // console.log(' &&&  NEW      >>>>>>>>>>>>>>>>>>>>>>>>>>	 STR >>  currentSelectedWorkSummaryWidget     setWidgetTaskFilters')
  workListStore.setWidgetTaskFilters(workListStore.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters);

  // console.log('  unk      setWidgetWorkFilters     >>>>>>>> workListStore.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters ')
  workListStore.setWidgetWorkFilters(workListStore.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters);

  // console.log(' STORE SET Mut 		x						setWorkWidgetArray  ')
  // this.$store.commit('setWorkWidgetArray', this.currentSelectedWorkSummaryWidget.widgetGridDataArray)

// console.log(" NEW       STORE SET Mut 		x						setWorkWidgetArray  ");
  workListStore.setWorkWidgetArray(workListStore.currentSelectedWorkSummaryWidget.widgetGridDataArray);

  // console.log('  STORE SET Mut 		x filterWidgetGrid')
  //
  // this.$store.commit('filterWidgetGrid', this.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters)

// console.log("  NEW      >>>>>>>>>>>>>>>>>>>>>>>>>>	 STR >> filterWidgetGrid   by  workListStore.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters ");
  workListStore.filterWidgetGrid(workListStore.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters);

  // * EMIT to DASH 2
// console.log("                         EMIT to DASH 2          ");
  // this.$emit('emitRender',1)
  // console.log("   NEW EMITTER v3                   EMIT to DASH 2          ");
  emit("emitRender", 1);
}

function GetWidgetList() {
// console.clear();
// console.log("   NEW  GetWidgetList      ");
  const testWIDGET = workListStore.getWidgetById(15);
  //    workListStore.currentSelectedWorkSummaryWidget =
// console.log("    CHECK      workListStore.currentSelectedWorkSummaryWidget");
  // console.log(  workListStore.currentSelectedWorkSummaryWidget )
// console.log("    CHECK      testWIDGET");
// console.log(testWIDGET);
}

onMounted(() => {
// console.log("onMounted() :      WidgetSummaryList WORK >>>>");
});
</script>

<style lang="scss" scoped>
#pie {
  height: 550px;
}

#pieGroup {
  height: 550px;
  background: darkred;
  padding: 6px;
}

.pies-container {
  margin: auto;
  //width: 460px;
  width: 100%;
  background: rgb(161, 83, 18);
  padding: 0px;
  overflow: auto;
  height: 30vh;
}

.pies-container > div {
  width: 100px;
  float: left;
  margin-top: -50px;
}

.long-title h3 {
  font-weight: 200;
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
